module.exports = __webpack_public_path__ + "img/device-disabled.771282be.png";